export default {
    apiKey: "AIzaSyCYD36EXKHWWl4ZC9Ng3aV3Ok4r6Rw2d58",
    authDomain: "scandinavia-service-site.firebaseapp.com",
    databaseURL: "https://scandinavia-service-site.firebaseio.com",
    projectId: "scandinavia-service-site",
    storageBucket: "scandinavia-service-site.appspot.com",
    messagingSenderId: "107442551960"
};
